import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Bill_Finder_Icon from "../../images/Bill Finder_Icon.svg";
import Bill_Finder_Icon_D from "../../images/Bill Finder_Icon_Disa.svg";
import GlobalTrack_Icon from "../../images/GlobalTrack_Icon.svg";
import GlobalTrack_Icon_D from "../../images/GlobalTrack_Icon_Disa.svg";
import LegisTrack_Icon from "../../images/LegisTrack_Icon.svg";
import LegisTrack_Icon_D from "../../images/LegisTrack_Icon_Disa.svg";
import Line_Icon from "../../images/Line_Icon.svg";
import LocalTrack_Icon from "../../images/LocalTrack_Icon.svg";
import LocalTrack_Icon_D from "../../images/LocalTrack_Icon_Disa.svg";
import QuickLinks_Icon from "../../images/QuickLinks_Icon.svg";
import QuickLinks_Icon_D from "../../images/QuickLinks_Icon_Disa.svg";
import RegsTrack_Icon from "../../images/RegsTrack_Icon.svg";
import RegsTrack_Icon_D from "../../images/RegsTrack_Icon_Disa.svg";
import STSComponent from "../STSComponent/STSComponent";
import "./css/TrackNav.scss";
import { globals } from '../../globals';

class TrackNav extends STSComponent {
  constructor(props) {
    super(props);
    this.state = {
      hoverItem: null
    };
  }

  getNavItems = () => {
    let navItems = [
      {
        name: "quicklinks", 
        permission: "Quick Links",
        label: { first: "Quick", second: "Links" },
        image: QuickLinks_Icon,
        imageD: LegisTrack_Icon_D, 
				url: `${globals.servicesUrl}/search/criteria.aspx?pageid=quicklinks`,
        corpUrl: `${globals.servicesUrl}/search/criteria.aspx?pageid=quicklinks`, 
        text: "A quick way of accessing, running and sharing custom reports you frequently use based on links you create in Legis, Regs or Local Track.", 
      },
      {
        name: "legis", 
        permission: "Legis",
        label: { first: "Legis", second: "Track" },
        image: LegisTrack_Icon,
        imageD: LegisTrack_Icon_D,
				url: `${globals.servicesUrl}/search/criteria.aspx?pageid=legis`,
        corpUrl: `${globals.corpUrl}/services/legislative-tracking-promo/`,
        text: "Create and generate custom reports of bills currently being tracked by your organization by using filters such as subject, state and history.", 
      },
      {
        name: "regs", 
        permission: "Regs",
        label: { first: "Regs", second: "Track" },
        image: RegsTrack_Icon,
        imageD: RegsTrack_Icon_D,
				url: `${globals.servicesUrl}/search/criteria.aspx?pageid=regs`,
        corpUrl: `${globals.corpUrl}/services/regulatory-tracking-promo/`, 
        text: "Create and generate custom reports of regulations currently being tracked by your organization by using filters such as subject, state and history.", 
      },
      {
        name: "local",
        permission: "Local",
        label: { first: "Local", second: "Track" },
        image: LocalTrack_Icon,
        imageD: LocalTrack_Icon_D,
				url: `${globals.servicesUrl}/search/criteria.aspx?pageid=local`,
        corpUrl: `${globals.corpUrl}/services/local-tracking-promo/`, 
        text: "Create and generate custom reports of ordinances/agendas currently being tracked by your organization by using filters such as subject, state and history.", 
      },
      {
        name: "global", 
        permission: "Canada",
        label: { first: "Canada", second: "Track" },
        image: GlobalTrack_Icon,
        imageD: GlobalTrack_Icon_D,
				url: `${globals.corpUrl}/services/canada-track/`,
        corpUrl: `${globals.corpUrl}/services/canada-track-promo/`, 
        text: "", 
      },
    ];

    navItems.forEach(item => {

      // QuickLinksOnly permission means the other tracks should be disabled. 
      let QuickLinksOnly = this.props.authData 
      && this.props.authData.Permissions 
      && this.props.authData.Permissions.some(
        (permission) => permission.indexOf('Quick Links: Show Only Quick Links') >= 0
      )

      if(!this.props.authData || !this.props.authData.Permissions || !this.props.authData.Permissions.some(
        (permission) => permission.indexOf(item.permission) >= 0
      ) || (QuickLinksOnly && item.permission != 'Quick Links')){
        item.image = item.imageD;
        item.url = item.corpUrl;
        item.disa = true;
      }
    })
 
    return navItems.reduce((a, b, index) => {
      if (index != 0) {
        a.push({
          image: Line_Icon,
        });
      }
      a.push(b);
      return a;
    }, []);
  };

  renderTrackIcons = () => {
    const navItems = this.getNavItems();

    return navItems.map((item, index) => {
      return item.permission ? (
        <div key={index} 
        onMouseEnter={ () => { this.setState({hoverItem: item.name}) } } 
        onMouseLeave={ () => { this.setState({hoverItem: null}) } } 
        >
        <a
          className="track-icon"
          key={index}
          href={item.url} 
          target={`${item.disa ? "_blank" : "_self" }`} 
        >
          <img className="track-icon" src={item.image} alt={item.permission} />
          <div className="track-label">
            <span className={`track-name ${item.disa ? "track-name-disa" : ""}`}>{item.label.first}</span>
            <span className={`track-type ${item.disa ? "track-type-disa" : ""}`}>{item.label.second}</span>
          </div>
        </a>
        </div>
      ) : (
        <div key={index} className="track-line">
          <img className="track-line" src={item.image} alt={item.permission} />
        </div>
      );
    });
  };

  Welcome(props) {
    let CustomBanner = props.authData.CustomBanner
    if (!CustomBanner) {
      return <h2 className="client-welcome text-center">Welcome to StateScape</h2>;
    } else{
      return <div>&nbsp;</div>
    }
  }

  render() {
    const { location, authData, showModal } = this.props
    const intranet = authData && authData.Permissions && authData.Permissions.includes('Intranet');

    const selectedTrackItem = this.getNavItems().find(i => i.name == this.state.hoverItem);

    if (intranet) {
      return null;
    }else{
      return (
        <div  className="container-fluid">
        <div className="container-fluid client-welcome-nav">
          {this.Welcome(this.props)}
          <div className="d-flex flex-row track-icons">
            {this.renderTrackIcons()}
          </div>
        </div>
        <div className="track-intro-container"><div className="track-intro">{ selectedTrackItem.text ? selectedTrackItem.text : "" }</div></div>
        </div>
      );
    }



  }

  static propTypes = {
    authData: PropTypes.object,
  };
}

export default connect(
  (state) => ({
    authData: state.auth.authData,
  }),
  {}
)(TrackNav);



// WEBPACK FOOTER //
// ./src/components/TrackNav/TrackNav.js